<template>
  <section>
      <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column label="编号" prop="id" align="center">
      </el-table-column>
      <el-table-column label="店铺名称" prop="dianpu_name" align="center">
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center">
      </el-table-column>
      <el-table-column label="是否审核" prop="is_verify" align="center">
        <template scope="scope">
          <div>{{verifyStatus[scope.row.is_verify]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button :plain="true" size="small" type="info"  @click="viewHandler(scope.row)">查看</el-button>
          <el-button v-if="scope.row.is_verify == 0" :plain="true" size="small" type="info"  @click="verify(scope.row)">确认审核</el-button>
          <el-button v-else :plain="true" size="small" type="info"  @click="verify(scope.row)">取消审核</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" size="large">
        <el-form ref="addForm" :model="addForm" :rules="formRules" label-width="100px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="店铺名称" prop="dianpu_name">
                    <el-input v-model="addForm.dianpu_name"></el-input>
                </el-form-item>
                <el-form-item label="店铺描述">
                    <el-input type="textarea" v-model="addForm.dianpu_describe"></el-input>
                </el-form-item>
                <el-form-item label="公司名称">
                    <el-input v-model="addForm.com_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="店铺图标">
                    <el-upload
                        class="avatar-uploader"
                        action="https://up.qbox.me"
                        :show-file-list='showUploadList'
                        :on-success="iconHandleSuccess"
                        :on-error="iconHandleError"
                        :before-upload="iconBeforeUpload"
                        :data='uploadForm'>
                        <img v-if="iconPicUrl" :src="iconPicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="微信号">
                    <el-input v-model="addForm.wechat_num"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="QQ号">
                    <el-input v-model="addForm.qq"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="联系方式">
                    <el-input v-model="addForm.tel"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="邮箱">
                    <el-input v-model="addForm.email"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="服务开始时间">
                    <el-date-picker
                    v-model="addForm.start_time"
                    type="datetime"
                    placeholder="选择开始时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="服务结束时间">
                    <el-date-picker
                    v-model="addForm.end_time"
                    type="datetime"
                    placeholder="选择结束时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
                <el-col :span="12">

                    <el-form-item label="身份证">
                        <el-input v-model="addForm.card_num"></el-input>
                    </el-form-item>
                </el-col>
                  </el-row>
                    <el-row>
        <el-form-item label="发货地" prop="fahuodi">
       <!--   <el-select v-model="addForm.fahuodi" placeholder="请选择">
            <el-option
              v-for="(item, index) in fahuodiArr"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
          -->
          <el-input v-model="addForm.fahuodi"></el-input>
        </el-form-item>

  </el-row>
        <el-row>
            <el-col :span="8">
                <el-form-item label="身份证正面">
                    <el-upload
                        class="avatar-uploader"
                        action="https://up.qbox.me"
                        :show-file-list='showUploadList'
                        :on-success="card1HandleSuccess"
                        :on-error="card1HandleError"
                        :before-upload="card1BeforeUpload"
                        :data='uploadForm'>
                        <img v-if="card1PicUrl" :src="card1PicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="身份证反面">
                    <el-upload
                        class="avatar-uploader"
                        action="https://up.qbox.me"
                        :show-file-list='showUploadList'
                        :on-success="card2HandleSuccess"
                        :on-error="card2HandleError"
                        :before-upload="card2BeforeUpload"
                        :data='uploadForm'>
                        <img v-if="card2PicUrl" :src="card2PicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="资质照片">
                    <el-upload
                        class="avatar-uploader"
                        action="https://up.qbox.me"
                        :show-file-list='showUploadList'
                        :on-success="zizhiHandleSuccess"
                        :on-error="zizhiHandleError"
                        :before-upload="zizhiBeforeUpload"
                        :data='uploadForm'>
                        <img v-if="zizhiPicUrl" :src="zizhiPicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item label="退款地址">
            <el-input type="textarea" v-model="addForm.tuikuan_addr"></el-input>
        </el-form-item>
        <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.remark"></el-input>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="submit" :loading="submitLoading">提交</el-button>
    </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog title="查看" v-model="viewFormVisible" size="large">
        <el-form ref="dianpuForm" :model="dianpuForm" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="店铺名称" prop="dianpu_name">
                        <el-input v-model="dianpuForm.dianpu_name"></el-input>
                    </el-form-item>
                    <el-form-item label="店铺描述">
                        <el-input type="textarea" v-model="dianpuForm.dianpu_describe"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称">
                        <el-input v-model="dianpuForm.com_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="店铺图标">
                        <img v-if="dianpuForm.dianpu_ico" :src="dianpuForm.dianpu_ico" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="微信号">
                        <el-input v-model="dianpuForm.wechat_num"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="QQ号">
                        <el-input v-model="dianpuForm.qq"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="联系方式">
                        <el-input v-model="dianpuForm.tel"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱">
                        <el-input v-model="dianpuForm.email"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="服务开始时间">
                        <el-input v-model="dianpuForm.start_time"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="服务结束时间">
                        <el-input v-model="dianpuForm.end_time"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="身份证">
                        <el-input v-model="dianpuForm.card_num"></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
            <el-row>
        <el-form-item label="发货地" prop="fahuodi">
         <!--    <el-select v-model="dianpuForm.fahuodi" placeholder="请选择">
         <el-option
              v-for="(item, index) in fahuodiArr"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>-->
              <el-input v-model="dianpuForm.fahuodi"></el-input>
        </el-form-item>

  </el-row>

      
         
            <el-row>
                <el-col :span="8">
                    <el-form-item label="身份证正面">
                        <img v-if="card1PicUrl" :src="card1PicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="身份证反面">
                        <img v-if="card2PicUrl" :src="card2PicUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="资质照片">
                        <img v-if="dianpuForm.zizhi_pic" :src="dianpuForm.zizhi_pic" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="退款地址">
                <el-input type="textarea" v-model="dianpuForm.tuikuan_addr"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="dianpuForm.remark"></el-input>
            </el-form-item>
        </el-form>
    </el-dialog>

  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';
     import {formatDate} from '../../static/js/date.js'
    import {formatPara} from '../../static/js/util.js'
        import {getQiniuToken} from '../../static/js/token.js'
  
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        viewFormVisible: false,
        dianpuForm: {},
        addForm: {
          id: 0,
          admin_id: 0,
                    dianpu_name: '',
                    dianpu_ico: '',
                    dianpu_describe: '',
                    com_name: '',
                    wechat_num: '',
                    qq: '',
                    tel: '',
                    email: '',
                    start_time: '',
                    end_time: '',
                    create_time: '',
                    card_num: '',
                    card_pic: '',
                    zizhi_pic: '',
                    tuikuan_addr: '',
                    fahuodi:'',
                    remark: '',
                    status: 0
        },
         showUploadList: false,
        iconPicUrl: '',
        card1PicUrl: '',
        card2PicUrl: '',
        zizhiPicUrl: '',
        uploadForm: {
            token: getQiniuToken(),
            key: null
        },
        fahuodi:'',
        formRules: {},  
        verifyStatus: basicdata.verifyStatus,
        card1PicUrl: '',
        card2PicUrl: '',
        fahuodiArr: basicdata.shengFen,
         addFormVisible: false,
         submitLoading: false,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/dianpu/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },

       addHandler() {
    
              this.addFormVisible = true;
              
            
      },
 //上传店铺图标
            iconBeforeUpload (file) {
                let fileName = 'dianpu/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
                let mime = file.name.split('.')[1];
                fileName += '.' + mime;
                this.uploadForm.key = fileName;
            },
            iconHandleSuccess (response, file, fileList) {
                this.iconPicUrl = basicdata.picUrl + this.uploadForm.key;
                this.result = '上传成功'
            },
            iconHandleError (error, response, file) {
                this.result = error.toString()
            },

            //上传身份证
            card1BeforeUpload (file) {
                let fileName = 'dianpu/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
                let mime = file.name.split('.')[1];
                fileName += '.' + mime;
                this.uploadForm.key = fileName;
            },
            card1HandleSuccess (response, file, fileList) {
                this.card1PicUrl = basicdata.picUrl + this.uploadForm.key;
                this.result = '上传成功'
            },
            card1HandleError (error, response, file) {
                this.result = error.toString()
            },

            //上传身份证
            card2BeforeUpload (file) {
                let fileName = 'dianpu/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
                let mime = file.name.split('.')[1];
                fileName += '.' + mime;
                this.uploadForm.key = fileName;
            },
            card2HandleSuccess (response, file, fileList) {
                this.card2PicUrl = basicdata.picUrl + this.uploadForm.key;
                this.result = '上传成功'
            },
            card2HandleError (error, response, file) {
                this.result = error.toString()
            },

            //上传商品主图片
            zizhiBeforeUpload (file) {
                let fileName = 'dianpu/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
                let mime = file.name.split('.')[1];
                fileName += '.' + mime;
                this.uploadForm.key = fileName;
            },
            zizhiHandleSuccess (response, file, fileList) {
                this.zizhiPicUrl = basicdata.picUrl + this.uploadForm.key;
                this.result = '上传成功'
            },
            zizhiHandleError (error, response, file) {
                this.result = error.toString()
            },
       
      // 提交
            submit() {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            let para = formatPara(Object.assign({}, this.addForm));
                            if(para.id == 0)
                                para.create_time = formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
                            para.dianpu_ico = this.iconPicUrl;
                            para.card_pic = this.card1PicUrl + ',' + this.card2PicUrl;
                            para.zizhi_pic = this.zizhiPicUrl;
                            //异步请求
                            this.$axios.post(config.api_url + '/dianpu',
                                para).then(response => {
                                if(response.data.state) {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success'
                                    });
                                     this.$refs['addForm'].resetFields();
                                    this.dianpu_ico = [];
                                    this.card_pic = [];
                                    this.zizhi_pic = [];
                                    this.addFormVisible = false;
                                     this.search();
                                } else {
                                    this.$message({
                                        message: '提交失败，请联系管理员',
                                        type: 'warning'
                                    });
                                }
                            }).catch(error => {
                                console.log(error);
                                this.$message({
                                    message: '提交异常，请联系管理员',
                                    type: 'error'
                                });
                            });
                        });
                    }
                });
            },
      viewHandler(row) {
        this.dianpuForm = row;
        let card_pic = this.dianpuForm.card_pic;
        if(card_pic && card_pic.split(',').length > 0) {
            this.card1PicUrl = card_pic.split(',')[0];
            this.card2PicUrl = card_pic.split(',')[1];
        }
        this.viewFormVisible = true;
      },
      verify(row) {
        this.$confirm('确认审核吗？', '提示', {}).then(() => {
            this.submitLoading = true;
            let verify = 0;
            if(row.is_verify == 0) {
                verify = 1;
            }
            //异步请求
            this.$axios.post(config.api_url + '/dianpu/verify/'+row.id+'/'+verify
            ).then(response => {
            if (response.data.state) {
                this.$message({
                    message: '成功',
                    type: 'success'
                });
                this.search();
            } else {
                this.$message({
                message: '提交失败，请联系管理员',
                type: 'error'
                });
            }
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '提交异常，请联系管理员',
                    type: 'error'
                });
            });
            this.submitLoading = false;
        });
      }
    },
     
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// index.vue?759d9d8a